<template>
    <div class="ticker-wrap-culture">
        <div class="ticker-wrap-culture-text box-a box">
            <div class="ticker-word-left">&nbsp;____<span class="barlow-semibold">VIBES</span></div>
            <div class="ticker-word-left">&nbsp;____<span class="barlow-semibold">VIBES</span></div>
            <div class="ticker-word-left">&nbsp;____<span class="barlow-semibold">VIBES</span></div>
            <div class="ticker-word-left">&nbsp;____<span class="barlow-semibold">VIBES</span></div>
            <div class="ticker-word-left">&nbsp;____<span class="barlow-semibold">VIBES</span></div>
            <div class="ticker-word-left">&nbsp;____<span class="barlow-semibold">VIBES</span></div>
        </div>
        <div class="ticker-wrap-culture-text box-b box">
            <div class="ticker-word-right">&nbsp;____<span class="barlow-semibold">VIBES</span></div>
            <div class="ticker-word-right">&nbsp;____<span class="barlow-semibold">VIBES</span></div>
            <div class="ticker-word-right">&nbsp;____<span class="barlow-semibold">VIBES</span></div>
            <div class="ticker-word-right">&nbsp;____<span class="barlow-semibold">VIBES</span></div>
            <div class="ticker-word-right">&nbsp;____<span class="barlow-semibold">VIBES</span></div>
            <div class="ticker-word-right">&nbsp;____<span class="barlow-semibold">VIBES</span></div>
        </div>
        <div class="ticker-wrap-culture-text box-c box">
            <div class="ticker-word-left2">&nbsp;____<span class="barlow-semibold">VIBES</span></div>
            <div class="ticker-word-left2">&nbsp;____<span class="barlow-semibold">VIBES</span></div>
            <div class="ticker-word-left2">&nbsp;____<span class="barlow-semibold">VIBES</span></div>
            <div class="ticker-word-left2">&nbsp;____<span class="barlow-semibold">VIBES</span></div>
            <div class="ticker-word-left2">&nbsp;____<span class="barlow-semibold">VIBES</span></div>
            <div class="ticker-word-left2">&nbsp;____<span class="barlow-semibold">VIBES</span></div>
        </div>
    </div>
</template>

<script>
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
export default {
    data() {
        return {
            tickerGSAP: null
        }
    },
    mounted() {
        ScrollTrigger.refresh();
        setTimeout(() => {
            this.initTickerTextLeft_culture();
            this.initTickerTextRight_culture();
            this.initTickerTextLeft2_culture();
            ScrollTrigger.create({
                trigger: ".box-a",
                pin: true,
                start: "center center",
                end: document.querySelector('#culture').scrollHeight - (document.querySelector('#ending').scrollHeight + (document.querySelector('.conclusion').scrollHeight + document.querySelector('.footer').scrollHeight) - 160)
            });
            ScrollTrigger.create({
                trigger: ".box-b",
                pin: true,
                start: "center center",
                end: document.querySelector('#culture').scrollHeight - (document.querySelector('#ending').scrollHeight + (document.querySelector('.conclusion').scrollHeight + document.querySelector('.footer').scrollHeight) - 160)
            });
            ScrollTrigger.create({
                trigger: ".box-c",
                pin: true,
                start: "center center",
                end: document.querySelector('#culture').scrollHeight - (document.querySelector('#ending').scrollHeight + (document.querySelector('.conclusion').scrollHeight + document.querySelector('.footer').scrollHeight) - 160)
            });
        }, 500)
        
    },
    methods: {
        initTickerTextLeft_culture() {
            const tickerTextLeft = gsap.utils.toArray(".ticker-word-left");

            let currentWidth = 0;
            let prevWidth = 0;
            let widest;

            tickerTextLeft.forEach((el, i) => {
                const width = gsap.getProperty(el, "width");
                if (width > prevWidth) {
                    widest = width;
                }
                gsap.set(el, { x: currentWidth });
                currentWidth += width;
                prevWidth = width;
            });

            const totalWidth = currentWidth;

            console.log(widest);

            const tl_left = gsap.to(".ticker-word-left", {
                x: `-=${totalWidth}`,
                repeat: -1,
                duration: 19,
                ease: "none",
                repeatRefresh: true,
                modifiers: {
                    x: gsap.utils.unitize((x) =>
                        gsap.utils.wrap(-widest, totalWidth - widest, x)
                    )
                }
            });
        },
        initTickerTextRight_culture() {
            const tickerTextRight = gsap.utils.toArray(".ticker-word-right");

            let currentWidth = 0;
            let prevWidth = 0;
            let widest;

            tickerTextRight.forEach((el, i) => {
                const width = gsap.getProperty(el, "width");
                if (width > prevWidth) {
                    widest = width;
                }
                gsap.set(el, { x: currentWidth });
                currentWidth += width;
                prevWidth = width;
            });

            const totalWidth = currentWidth;

            console.log(widest);

            const tl_left = gsap.to(".ticker-word-right", {
                x: `+=${totalWidth}`,
                repeat: -1,
                duration: 23,
                ease: "none",
                repeatRefresh: true,
                modifiers: {
                    x: gsap.utils.unitize((x) =>
                        gsap.utils.wrap(-widest, totalWidth - widest, x)
                    )
                }
            });
        },
        initTickerTextLeft2_culture() {
            const tickerTextLeft = gsap.utils.toArray(".ticker-word-left2");

            let currentWidth = 0;
            let prevWidth = 0;
            let widest;

            tickerTextLeft.forEach((el, i) => {
                const width = gsap.getProperty(el, "width");
                if (width > prevWidth) {
                    widest = width;
                }
                gsap.set(el, { x: currentWidth });
                currentWidth += width;
                prevWidth = width;
            });

            const totalWidth = currentWidth;

            console.log(widest);

            const tl_left = gsap.to(".ticker-word-left2", {
                x: `-=${totalWidth}`,
                repeat: -1,
                duration: 30,
                ease: "none",
                repeatRefresh: true,
                modifiers: {
                    x: gsap.utils.unitize((x) =>
                        gsap.utils.wrap(-widest, totalWidth - widest, x)
                    )
                }
            });
        },
    },
    beforeDestroy() {
        setTimeout(() => {
            ScrollTrigger.getAll().forEach(t => t.kill());
        }, 500)
    }
}
</script>

<style scoped lang="scss">
.ticker-wrap-culture-text {
    // overflow-x: hidden;
    white-space: nowrap;
    color: #000;
}

.ticker-word-left {
    left: 0;
    top: -500px;
    width: auto;
    position: absolute;
    font-size: 8rem;
    display: inline-block;
}

.ticker-word-right {
    left: 0;
    top: -360px;
    width: auto;
    position: absolute;
    font-size: 8rem;
    display: inline-block;
}

.ticker-word-left2 {
    left: 0;
    top: -220px;
    width: auto;
    position: absolute;
    font-size: 8rem;
    display: inline-block;
}

.box {
  position: absolute;
//   left: 50%;
//   transform: translateX(-50%);
  will-change: transform;
}

.box-a {
  z-index: 10;

    @media screen and (max-width: 640px) {
        visibility: hidden;
    }
}

.box-b {
  z-index: 15;
}

.box-c {
  z-index: 10;
}

</style>